/**
 * @desc 修改sku
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: Array<defs.basics.ProductSkuUpdateRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/productSku/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
